import React, { useContext, useState } from 'react'

import { PageProps } from './Page.types'
import TabProvider from '../Tabstrip/TabProvider'

export const Context = React.createContext(null)

const Page: React.FC<PageProps> = ({ background, height = '100vh', tabProps = {}, withTabs, children }) => {
    const [internalHeight, setInternalHeight] = useState(height)
    const [pageHeaderHeight, setPageHeaderHeight] = useState(0)
    const [pageContentHeight, _setPageContentHeight] = useState(0)
    const style = {
        height: internalHeight || '100vh',
        background,
    }

    const context: any = {
        setPageHeaderHeight,
        pageContentHeight,
        pageHeaderHeight,
    }

    return (
        <Context.Provider value={context}>
            <TabProvider {...tabProps}>
                <div style={style} data-testid='Page' className='r-page-container'>
                    {' '}
                    {children}
                </div>
            </TabProvider>
        </Context.Provider>
    )
}

export default Page
